import './RenewalsPortalPageHeader.css';
import { injectIntl } from 'react-intl';

import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Select } from '@material-ui/core';
import SearchBar from '../../../widgets/SearchBar/SearchBar';
import InfoBox from '../../../widgets/InfoBox/InfoBox';
import { days } from './days';

const infoBox = (box, key) => (
  <div key={key} className="renewal-info-box m-b-15">
    <div onClick={box.onClick}>
      <InfoBox
        icon={box.icon}
        color={box.color}
        iconColor={box.iconColor}
        title={box.title}
        value={box.count}
      />
    </div>
  </div>
);

const infoBoxes = (props) => (
  <div className="info-boxes">
    {props.filterDetails.map(infoBox)}
  </div>
);

const filterSelects = (props) => (
  <span className="row renewals-portal-filter-selects">
<Select
  className="col-xs-12 col-sm-6 col-md-2 m-b-15"
  value={props.selectedBranchRouteNumber}
  onChange={(event) => {
    event.preventDefault();
    props.onChangeRoute(event.target.value);
  }}
>
{props.routes.map((route, index) => (
  <MenuItem key={index} value={route.branchRouteNumber}>
    {route.display}
  </MenuItem>
))}
</Select>
<Select
  className="col-xs-12 col-sm-6 col-md-2 m-b-15"
  value={props.selectedDay}
  onChange={(event) => {
    event.preventDefault();
    props.onChangeDay(event.target.value);
  }}
>
{days(props).map((day, index) => (
  <MenuItem key={index} value={day.dayId}>
    {day.display}
  </MenuItem>
))}
</Select>
</span>
);

class RenewalsPortalPageHeader extends React.Component {
  constructor(props) {
    super(props);
    this.searchBarRef = React.createRef();
  }

  onClearSearch() {
    this.searchBarRef.current.onClearSearch();
  }

  render() {
    return (
      <div>
        <div className="row">
          <div
            className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15"
            style={{ position: 'relative', display: 'inline-block' }}
          >
            <SearchBar
              ref={this.searchBarRef}
              clearSearch={this.props.clearSearch}
              onSearch={this.props.onSearch}
              placeHolder={this.props.intl.formatMessage({
                id: 'customer_name_or_number'
              })}
            />
          </div>
        </div>
        {infoBoxes(this.props)}
        {filterSelects(this.props)}
      </div>
    );
  }
}

RenewalsPortalPageHeader.propTypes = {
  onSearch: PropTypes.func,
  filterDetails: PropTypes.array,
  selectedBranchRouteNumber: PropTypes.string.isRequired,
  routes: PropTypes.array.isRequired,
  onChangeRoute: PropTypes.func.isRequired,
  selectedDay: PropTypes.number.isRequired,
  onChangeDay: PropTypes.func.isRequired
};

export default injectIntl(RenewalsPortalPageHeader, { forwardRef: true });